(() => {
  if (customElements.get("speaking-writing-slider")) return;

  class SpeakingWritingSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;

      this.autoplayDelay = Number(this.dataset.autoplayDelay) || 3000;
      this.mediaQuery = window.matchMedia("(max-width: 749px)");
      this.previousButton = this.querySelector("[data-speaking-writing-previous]");
      this.nextButton = this.querySelector("[data-speaking-writing-next]");
      this.handlePreviousClick = event => this.onPreviousClick(event);
      this.handleNextClick = event => this.onNextClick(event);
      this.handleViewportChange = () => this.updateAutoplay();
      this.handleVisibilityChange = () => this.updateAutoplay();

      if (!this.initSwiper()) {
        window.requestAnimationFrame(() => this.connectedCallback());
        return;
      }

      this.previousButton?.addEventListener("click", this.handlePreviousClick);
      this.nextButton?.addEventListener("click", this.handleNextClick);
      this.mediaQuery.addEventListener("change", this.handleViewportChange);
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
      this.dataset.initialized = "true";
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener("click", this.handlePreviousClick);
      this.nextButton?.removeEventListener("click", this.handleNextClick);
      this.mediaQuery?.removeEventListener("change", this.handleViewportChange);
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    initSwiper() {
      if (typeof Swiper === "undefined") return false;

      this.querySelectorAll("img, picture").forEach(node => {
        node.setAttribute("draggable", "false");
      });

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        rewind: true,
        speed: 520,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        touchStartPreventDefault: false,
        threshold: 8,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: this.autoplayDelay,
          disableOnInteraction: false,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            speed: 520,
          },
        },
      });

      this.updateAutoplay();
      return true;
    }

    onPreviousClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.swiper?.slidePrev();
      this.updateAutoplay();
    }

    onNextClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.swiper?.slideNext();
      this.updateAutoplay();
    }

    updateAutoplay() {
      if (!this.swiper?.autoplay) return;

      if (this.mediaQuery.matches && !document.hidden) {
        this.swiper.autoplay.start();
        return;
      }

      this.swiper.autoplay.stop();
    }
  }

  customElements.define("speaking-writing-slider", SpeakingWritingSlider);
})();
